import { INTEGRATION_TYPES } from "./device";

const APP_ID_ADS = "com.vistarmedia.apps.ads" as const;
const APP_ID_ALL = -4 as const;
const APP_ID_DYNAMIC_CREATIVE = -6 as const; // vistar.dynamic-creative
const APP_ID_PLAYER = -2 as const;
const APP_ID_SINGLE_ZONE_SCHEDULER =
  "com.vistarmedia.schedulers.single-zone" as const;
const APP_ID_UAS = "com.vistarmedia.apps.uas" as const;
const APP_ID_VSA = "com.vistarmedia.apps.vsa" as const;
const APP_ID_VSA_BACKUP_LOOP = -8 as const; // vsa.backup-loop
const APP_ID_VSA_SCHEDULE = -7 as const; // vsa.schedule
const APP_ID_VISTAR_PLAYER = -5 as const;
const BLACK_SCREEN_APP_ID = "__bs" as const;

const APP_MANIFEST_V3 = 3 as const;

const PARAM_TYPE_ARRAY = "ARRAY" as const;
const PARAM_TYPE_BOOLEAN = "BOOLEAN" as const;
const PARAM_TYPE_NUMBER = "NUMBER" as const;
const PARAM_TYPE_STRING = "STRING" as const;

const APP_PARAM_TYPES = [
  PARAM_TYPE_ARRAY,
  PARAM_TYPE_BOOLEAN,
  PARAM_TYPE_NUMBER,
  PARAM_TYPE_STRING,
] as const;

type AppParamType = (typeof APP_PARAM_TYPES)[number];

const EMPTY_VALUE: Record<AppParamType, unknown> = {
  [PARAM_TYPE_STRING]: "",
  [PARAM_TYPE_NUMBER]: null,
  [PARAM_TYPE_BOOLEAN]: null,
  [PARAM_TYPE_ARRAY]: [],
};

function getAppParamKey(appName: string | number, paramName: string): string {
  return `${appName}.${paramName}`;
}

const ADS_APP_PARAMS = {
  API_KEY: getAppParamKey(APP_ID_ADS, "api_key"),
  HEIGHT: getAppParamKey(APP_ID_ADS, "height"),
  NETWORK_ID: getAppParamKey(APP_ID_ADS, "network_id"),
  STATIC_DURATION: getAppParamKey(APP_ID_ADS, "static_duration"),
  SUPPORTED_MEDIA: getAppParamKey(APP_ID_ADS, "supported_media"),
  URL: getAppParamKey(APP_ID_ADS, "url"),
  VENUE_ID: getAppParamKey(APP_ID_ADS, "venue_id"),
  WIDTH: getAppParamKey(APP_ID_ADS, "width"),
} as const;

const SYSTEM_MANAGED_APPS = [APP_ID_ADS] as const;

const SYSTEM_MANAGED_NETWORK_PARAMS = [
  ADS_APP_PARAMS.API_KEY,
  ADS_APP_PARAMS.NETWORK_ID,
  ADS_APP_PARAMS.URL,
] as const;

const SYSTEM_MANAGED_DEVICE_PARAMS: Record<string, ReadonlyArray<string>> = {
  [INTEGRATION_TYPES.AGENT]: [ADS_APP_PARAMS.VENUE_ID],
  [INTEGRATION_TYPES.PLAYER]: [
    ADS_APP_PARAMS.HEIGHT,
    ADS_APP_PARAMS.SUPPORTED_MEDIA,
    ADS_APP_PARAMS.VENUE_ID,
    ADS_APP_PARAMS.WIDTH,
  ],
  [INTEGRATION_TYPES.THIRDPARTY]: [
    ADS_APP_PARAMS.HEIGHT,
    ADS_APP_PARAMS.STATIC_DURATION,
    ADS_APP_PARAMS.SUPPORTED_MEDIA,
    ADS_APP_PARAMS.VENUE_ID,
    ADS_APP_PARAMS.WIDTH,
  ],
};

const SYNTHETIC_APPLICATION_SOURCES: Record<number, string> = {
  [APP_ID_PLAYER]: "Player",
  [APP_ID_DYNAMIC_CREATIVE]: "Dynamic Creative",
  [APP_ID_VSA_SCHEDULE]: "VSA Schedule",
  [APP_ID_VSA_BACKUP_LOOP]: "VSA Backup Loop",
  [APP_ID_VISTAR_PLAYER]: "Vistar Player",
};

export {
  APP_ID_ADS,
  APP_ID_ALL,
  APP_ID_DYNAMIC_CREATIVE,
  APP_ID_PLAYER,
  APP_ID_SINGLE_ZONE_SCHEDULER,
  APP_ID_UAS,
  APP_ID_VISTAR_PLAYER,
  APP_ID_VSA,
  APP_ID_VSA_BACKUP_LOOP,
  APP_ID_VSA_SCHEDULE,
  APP_MANIFEST_V3,
  APP_PARAM_TYPES,
  type AppParamType,
  BLACK_SCREEN_APP_ID,
  EMPTY_VALUE,
  PARAM_TYPE_ARRAY,
  PARAM_TYPE_BOOLEAN,
  PARAM_TYPE_NUMBER,
  PARAM_TYPE_STRING,
  SYSTEM_MANAGED_APPS,
  SYSTEM_MANAGED_DEVICE_PARAMS,
  SYSTEM_MANAGED_NETWORK_PARAMS,
  SYNTHETIC_APPLICATION_SOURCES,
};
